module.exports = __webpack_public_path__ + "static/media/rain.37177c69.mp3";